import { Box, Typography } from '@mui/material'

import FeaturesContainer from '@ecm/ui/component/FeaturesContainer'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

const features = [
  {
    category: 'Protect. Organize. Integrate.',
    features: [
      {
        description: (
          <>
            <b>Working remote or managing your own business? </b>Safeguard your private information
            by using one of our 80+ virtual business addresses to share with customers and vendors,
            rather than your personal address.
          </>
        ),
        title: 'PROTECT',
      },
      {
        description: (
          <>
            Never lose track of your mail again. Organize your mail into a digital filing cabinet
            with tags and folders by people or departments. You can even automate your account!
          </>
        ),
        title: 'ORGANIZE',
      },
      {
        description: (
          <>
            Save time and energy with our powerful software integrations to popular financial and
            cloud applications, such as
            <b> DropBox, Quickbooks, Google Drive, Bill.com, and more.</b>
          </>
        ),
        title: 'INTEGRATE',
      },
    ],
  },
  {
    category: 'Print. Ship. Deposit.',
    features: [
      {
        description: (
          <>
            Our scan quality is so good you`ll think it`s the original. Here is how it works,{' '}
            <b>your mail is scanned and delivered to you as a high-quality, high-resolution PDF</b>{' '}
            that you can download and print.
          </>
        ),
        title: 'PRINT',
      },
      {
        description: (
          <>
            We make it easy for you to ship your mail or parcels around the globe
            <b> directly from your inbox — from anywhere, anytime, and on any device.</b> You can
            even request same-day shipments or schedule them for a future date.
          </>
        ),
        title: 'SHIP',
      },
      {
        description: (
          <>
            Our check deposit service scans your checks, electronically endorses them, generates a
            deposit slip, and mails them directly to your bank. Use multiple banks or accounts, and
            deposit any amount.
          </>
        ),
        title: 'DEPOSIT',
      },
    ],
  },
  {
    category: 'Share. Save. Automate.',
    features: [
      {
        description: (
          <>
            With a simple click of a button, you can
            <b> share your high-quality, high-resolution, color PDFs with anyone</b> even if they
            are not an Earth Class Mail customer. We provide you with a unique link for seamless
            access.
          </>
        ),
        title: 'SHARE',
      },
      {
        description: (
          <>
            Get <b>unlimited cloud storage</b> as long as you are a customer with no extra fees or
            end dates! Save with our bundled packages with the Personal MailBox and Shared MailBox
            plans you get respectively 5 and 25 pieces of mail scanned and stored, with unlimited
            shredding and recycling.
          </>
        ),
        title: 'SAVE',
      },
      {
        description: (
          <>
            You have all the control to set your preferred actions:
            <b> request check deposits, securely shred and recycle,</b> forward your mail, or share
            documents to popular cloud and financial software.
          </>
        ),
        title: 'AUTOMATE',
      },
    ],
  },
]

const Features = () => (
  <FeaturesContainer>
    {features.map(({ category, features }) => (
      <Box key={category}>
        <Typography
          variant="h4"
          component="h3"
          color={Color.white.normal}
          textAlign="center"
          mb="1em"
        >
          {category}
        </Typography>
        <Box
          m="0 auto 5em"
          maxWidth={{ md: 'md', xs: 'sm' }}
          display="grid"
          gridTemplateColumns={{ md: 'repeat(3, 1fr)', xs: '1fr' }}
          gap="2em"
        >
          {features.map(({ title, description }) => (
            <Box key={title} p="2em 1.5em" bgcolor={Color.saint.darkest} borderRadius="8px">
              <Box textAlign="center" mb="3em">
                <CloudflareImage
                  src={`/images/icon/${title.toLowerCase()}.svg`}
                  width={90}
                  height={70}
                />
              </Box>
              <Typography variant="overline" color={Color.saint.lightest} mb="1em">
                {title}
              </Typography>
              <Typography variant="p3" color={Color.white.normal} mb="0">
                {description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    ))}
  </FeaturesContainer>
)

export default Features
